import actions from '@/core/store/penalidades/actions'
import mutations from '@/core/store/penalidades/mutations'
import state from '@/core/store/penalidades/state'
import dadosGerais from '@/core/store/penalidades/dados-gerais'
import itens from '@/core/store/penalidades/itens'
import notificacoes from '@/core/store/penalidades/notificacoes'

export default {
	actions,
	state,
	mutations,
	modules: {
		dadosGerais,
		itens,
		notificacoes,
	},
}
